import React, { useEffect, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Close from "@material-ui/icons/Close";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

import CheckboxSelect from 'views/component/CheckboxSelect';

const useStyles = makeStyles(styles);
const useStylesSelect = makeStyles(selectStyles);

export default function EditTable(props) {
  const classes = useStyles();
  const selectClasses = useStylesSelect();
  const {
    tableHead,
    tableCols,
    tableData,
    tableHeaderColor,
    colorsColls,
    coloredColls,
    customCellClasses,
    customClassesForCells,
    striped,
    customHeadCellClasses,
    customHeadClassesForCells,
    onChange,
    onRemove,
    filter,
    underlineColor,
    fixed,
    required,
    types,
    selects,
    selectsFilter,
    checkSelects,
  } = props;
  const [innerData, setData] = useState(tableData);
  const [underline, setUnderline] = useState(underlineColor);

  const handleValueChange = function (row, colName, value) {
    onChange(row, colName, value);
  }
  const handleRemoveClick = function (row) {
    onRemove(row);
  }
  useEffect(() => {
    if (tableData !== innerData) {
      setData(tableData);
    }
  }, [tableData, innerData]);
  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor]}>
            <TableRow className={classes.tableRow + " " + classes.tableRowHead + " " + classes.tableHeadFontSize}>
              {tableHead.map((prop, key) => {
                const tableCellClasses =
                  classes.tableHeadCell +
                  " " +
                  classes.tableCell +
                  " " +
                  cx({
                    [customHeadCellClasses[
                      customHeadClassesForCells.indexOf(key)
                    ]]: customHeadClassesForCells.indexOf(key) !== -1
                  });
                return (
                  <TableCell className={tableCellClasses} key={key}>
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {innerData.length === 0 ? (
            <TableRow key={0}><TableCell className={classes.tableCell} colSpan={tableHead.length}>데이터가 없습니다</TableCell></TableRow>
          ) : null}
          {innerData.length !== 0 && filter && innerData.filter((item) => filter(item)).length === 0 ? (
            <TableRow key={0}><TableCell className={classes.tableCell} colSpan={tableHead.length}>검색된 데이터가 없습니다</TableCell></TableRow>
          ) : null}
          {innerData.map((prop, key) => {
            var rowColor = "";
            var rowColored = false;
            if (prop.color !== undefined) {
              rowColor = prop.color;
              rowColored = true;
              prop = prop.data;
            }
            const tableRowClasses = cx({
              [classes.tableRowBody]: true,
              [classes[rowColor + "Row"]]: rowColored,
              [classes.tableStripedRow]: striped && key % 2 === 0
            });

            return filter && !filter(prop) ? null : (
              <TableRow
                key={key}
                className={classes.tableRow + " " + tableRowClasses}
              >
                {(tableCols ? tableCols : prop).map((colName) => {
                  const data = tableCols ? prop[colName] : colName;
                  const tableCellClasses =
                    classes.editTableCell +
                    " " +
                    cx({
                      [classes[colorsColls[coloredColls.indexOf(colName)]]]:
                        coloredColls.indexOf(colName) !== -1,
                      [customCellClasses[customClassesForCells.indexOf(colName)]]:
                        customClassesForCells.indexOf(colName) !== -1
                    });
                  return (
                    <TableCell className={tableCellClasses} key={colName}>
                      {selects && selects[colName] ?
                        <FormControl fullWidth className={selectClasses.selectFormControlInfo}>
                          <Select MenuProps={{ className: selectClasses.selectMenu }} classes={{ select: selectClasses.select }}
                            value={data} onChange={e => { handleValueChange(key, colName, e.target.value) }} inputProps={{ id: colName }}>
                            {(selectsFilter && selectsFilter[colName] ? selectsFilter[colName](prop, selects[colName]) : selects[colName]).map((item) => {
                              return <MenuItem classes={{ root: selectClasses.selectMenuItemInfo, selected: selectClasses.selectMenuItemSelectedInfo }}
                                value={item.value} key={item.value}>
                                {item.label}
                                {item.image ? <img src={item.image.src} width={item.image.width} style={{ marginLeft: 10 }} alt={item.label} /> : ''}
                              </MenuItem>;
                            })}
                          </Select>
                        </FormControl>
                        : checkSelects && checkSelects[colName] ?
                          <CheckboxSelect items={checkSelects[colName]} fullWidth
                            handleItemClick={value => handleValueChange(key, colName, data.includes(value) ? data.filter(item => item !== value) : [value, ...data])}
                            selectedItemList={data} />
                          :
                          <FormControl fullWidth className={selectClasses.formControlInfo}>
                            <CustomInput onTable formControlProps={{ fullWidth: true }} underlineColor={underline} 
                              error={required && required.includes(colName) && !data}
                              inputProps={{
                                type: types && types[colName] ? types[colName] : 'text',
                                value: data,
                                onChange: e => handleValueChange(key, colName, e.target.value),
                                disabled: (fixed && fixed.includes(colName)),
                                placeholder: (required && required.includes(colName)) ? 'required' : undefined,
                              }}
                            />
                          </FormControl>
                      }
                    </TableCell>
                  );
                })}
                <TableCell className={classes.editTableCell} key={key}>
                  <Button className={classes.actionButton} key="key" color="danger" onClick={e => handleRemoveClick(key)}>
                    <Close className={classes.icon} />
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div >
  );
}

EditTable.defaultProps = {
  tableHeaderColor: "gray",
  colorsColls: [],
  coloredColls: [],
  striped: false,
  customCellClasses: [],
  customClassesForCells: [],
  customHeadCellClasses: [],
  customHeadClassesForCells: []
};

EditTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  // Of(PropTypes.arrayOf(PropTypes.node)) || Of(PropTypes.object),
  tableData: PropTypes.array,
  coloredColls: PropTypes.arrayOf(PropTypes.number),
  // Of(["warning","primary","danger","success","info","rose","gray"]) - colorsColls
  colorsColls: PropTypes.array,
  customCellClasses: PropTypes.arrayOf(PropTypes.string),
  customClassesForCells: PropTypes.arrayOf(PropTypes.number),
  customHeadCellClasses: PropTypes.arrayOf(PropTypes.string),
  customHeadClassesForCells: PropTypes.arrayOf(PropTypes.number),
  striped: PropTypes.bool,
  tableCols: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  filter: PropTypes.func,
  underlineColor: PropTypes.string,
  fixed: PropTypes.arrayOf(PropTypes.string),
  required: PropTypes.arrayOf(PropTypes.string),
  types: PropTypes.any,
  selects: PropTypes.any,
  selectsFilter: PropTypes.any
};
